import { render, staticRenderFns } from "./ProviderSearch.vue?vue&type=template&id=c66facbc&"
import script from "./ProviderSearch.vue?vue&type=script&lang=js&"
export * from "./ProviderSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports